"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemoryOnlyConfigurationStore = exports.MemoryStore = void 0;
class MemoryStore {
    constructor() {
        this.store = {};
        this.initialized = false;
    }
    get(key) {
        return this.store[key] ?? null;
    }
    entries() {
        return this.store;
    }
    getKeys() {
        return Object.keys(this.store);
    }
    isInitialized() {
        return this.initialized;
    }
    setEntries(entries) {
        this.store = { ...entries };
        this.initialized = true;
    }
}
exports.MemoryStore = MemoryStore;
class MemoryOnlyConfigurationStore {
    constructor() {
        this.servingStore = new MemoryStore();
        this.initialized = false;
        this.configFetchedAt = null;
        this.configPublishedAt = null;
        this.environment = null;
        this.format = null;
    }
    init() {
        this.initialized = true;
        return Promise.resolve();
    }
    get(key) {
        return this.servingStore.get(key);
    }
    entries() {
        return this.servingStore.entries();
    }
    getKeys() {
        return this.servingStore.getKeys();
    }
    async isExpired() {
        return true;
    }
    isInitialized() {
        return this.initialized;
    }
    async setEntries(entries) {
        this.servingStore.setEntries(entries);
        this.initialized = true;
        return true;
    }
    getEnvironment() {
        return this.environment;
    }
    setEnvironment(environment) {
        this.environment = environment;
    }
    getConfigFetchedAt() {
        return this.configFetchedAt;
    }
    setConfigFetchedAt(configFetchedAt) {
        this.configFetchedAt = configFetchedAt;
    }
    getConfigPublishedAt() {
        return this.configPublishedAt;
    }
    setConfigPublishedAt(configPublishedAt) {
        this.configPublishedAt = configPublishedAt;
    }
    getFormat() {
        return this.format;
    }
    setFormat(format) {
        this.format = format;
    }
}
exports.MemoryOnlyConfigurationStore = MemoryOnlyConfigurationStore;
//# sourceMappingURL=memory.store.js.map